const WORDS = [
  "Panificio",
  "Caffetteria",
  "Salateria",
  "100% Artigianale",
  "Fresco ogni giorno",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <section
      className="bg-[#2A1B14] text-[#FDFBF7] py-6 sm:py-8 overflow-hidden border-y border-[#2A1B14]"
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0">
            {row.map((w, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="font-display italic font-light text-4xl sm:text-6xl px-6 sm:px-10 whitespace-nowrap">
                  {w}
                </span>
                <span className="text-[#D4AF37] text-2xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
